import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import Search from "../../components/Form/Search.js";
import "../../assets/styles/pages/Usuarios.scss";
import "pure-css-loader/src/loader-default.sass";
import business from "../../services/business.js";
import config from "../../config/config.js";
import Layout from "../../components/Layout.js";
import MenuDots from "../../components/MenuDots.js";
import ModalMateriaisAdmin from "../../components/Modais/ModalMateriaisAdmin.js";
import tools from "../../lib/tools.js";

export default function Materiais() {
    document.title = "säästo";
    const [pager, setPager] = useState({
        page: 1,
        total_pages: 0,
        total_rows: 0,
    });

    const [listagem, setListagem] = useState([]);
    const [showModalMateriais, setShowModalMateriais] = useState(false);
    const [material, setMaterial] = useState({});
    const [isMobile, setIsMobile] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filtroBusca, setFiltroBusca] = useState("");

    const handleSaveSuccess = async () => {
        // Atualiza a lista de materiais após o salvamento
        await getSearch();
    };

    const childToParent = async () => {
        setShowModalMateriais(true);
    };

    const openModal = async (event = {}, row = {}) => {
        event?.preventDefault();
        if (row?.id) setMaterial(row);
        setShowModalMateriais(true);
    };

    const hideModalMateriais = async (event) => {
        event?.preventDefault();
        setShowModalMateriais(false);
        const body = document.body;
        body.classList.remove("overflow-hidden");
    };

    const menuItens = [
        {
            label: "Editar",
            icon: "icon-edit blue i-25",
            className: "menu-icon",
            onClick: openModal,
            disabled: !config.temPermissao("admin:materiais:editar"),
        }
    ];

    const handlePageClick = (e) => {
        getSearch(e.selected + 1, filtroBusca);
    };

    const getSearch = async (page = null, value = "", loading = true) => {
        setLoading(loading);
        let materiais = await business.getAllMateriaisAdmin(
            page === null ? pager.page : page,
            20,
            value,
            [6]
        );
        setListagem(materiais?.response || []);
        if (
            materiais?.response &&
            pager.page &&
            materiais?.pager?.paginas > 0 &&
            materiais?.pager?.paginas < pager.page
        ) {
            pager.page = 1;
            return getSearch();
        }
        pager.page = materiais?.pager?.pagina;
        setPager({
            page: materiais?.pager?.pagina,
            total_pages: materiais?.pager?.paginas,
            total_rows: materiais?.pager?.total,
        });
        setLoading(false);
        setSearchLoading(false);
    };

    const handleWindowSizeChange = (mobileSize) => {
        let checkIsMobile = window.innerWidth < mobileSize;
        setIsMobile(checkIsMobile);
    };

    useEffect(() => {
        window.addEventListener("resize", () => {
            return handleWindowSizeChange(1180);
        });
    }, []);

    useEffect(() => {
        (async () => {
            await getSearch();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Layout className="view-listagem">
            {showModalMateriais && (
                <ModalMateriaisAdmin
                    show={showModalMateriais}
                    hideModal={hideModalMateriais}
                    dto={material}
                    onSaveSuccess={handleSaveSuccess}
                />
            )}
            <p className="page-title">
                Administração / <span className="blue-text">Materias</span>
            </p>
            <h2 className="title flex jc-sb ai-fe black-text mb-40 gap-10">
                Materiais
                {config.temPermissao("admin:materiais:cadastrar") && (
                    <button
                        className="btn btn-primary f700-16 mobile"
                        onClick={childToParent}
                    >
                        Cadastrar
                    </button>
                )}
            </h2>
            <div className="flex jc-sb ai-fc mb-60">
                <div className="container-search-filter flex ai-fc jc-sb gap-25">
                    <Search
                        onChange={(value) => {
                            setSearchLoading(true);
                            getSearch(1, value, false);
                            setFiltroBusca(value);
                        }}
                        searchOnTyping={isMobile}
                        loading={searchLoading}
                    />
                </div>

                <div className="flex ai-fc gap-30 desktop">
                    {config.temPermissao("admin:materiais:cadastrar") && (
                        <button className="btn btn-primary f700-16" onClick={openModal}>
                            Cadastrar
                        </button>
                    )}
                </div>
            </div>

            {loading ? (
                <div className="loader loader-default is-active" />
            ) : (
                <div>
                    <div className="table-mobile">
                        {listagem.map((p, i) => {
                            return (
                                <div className="item pointer" key={`mobile-${i}`}>
                                    <div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Código
                                            <span>{p.codigo}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Descrição
                                            <span>{p.desc}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Valor
                                            <span>{tools.formatCurrency(p.valor_unitario)}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Tipo
                                            <span className={`fn-16 text-center tag-perfil ${parseInt(p.id_materiais_tipo) === 1 ? ' operadora' : ' desempatador'}`}>{p.desc_materiais_tipo}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Status
                                            <span>{parseInt(p.status) === 1 ? <strong>Ativo</strong> : "Destivado"}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Tabela base
                                            <span>{p.desc_operadora ? p.desc_operadora : "säästö"}</span>
                                        </div>
                                    </div>
                                    <div className="w-100 flex jc-fc">
                                        <MenuDots
                                            row={p}
                                            menuItens={menuItens}
                                            menuPositionTop={true}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                        {(!listagem || !listagem?.length) && (
                            <div className="item pointer" key={`mobile-0`}>
                                Nenhum resultado encontrado.
                            </div>
                        )}
                    </div>
                    <table className="w-100 table-desktop">
                        <thead className="f300-16">
                            <tr>
                                <th className="bold">Código</th>
                                <th className="text-left bold">Descrição</th>
                                <th className="text-center bold">Valor</th>
                                <th className="text-center bold">Tipo</th>
                                <th className="text-center bold">Status</th>
                                <th className="text-center bold">Tabela base</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {listagem.map((p, i) => {
                                return (
                                    <tr key={`desktop-${i}`}>
                                        <td className="fn-16"><strong>{p.codigo}</strong></td>
                                        <td className="fn-16">{p.desc}</td>
                                        <td className="fn-16 text-center">{tools.formatCurrency(p.valor_unitario)}</td>
                                        <td className={`fn-16 text-center tag-perfil ${parseInt(p.id_materiais_tipo) === 1 ? ' operadora' : ' desempatador'}`}>{p.desc_materiais_tipo}</td>
                                        <td className="fn-16 text-center">{parseInt(p.status) === 1 ? "Ativo" : "Desativado"}</td>
                                        <td className="fn-16 text-center">{p.desc_operadora ? p.desc_operadora : "säästö"}</td>
                                        <td className="text-center" style={{ width: "35px" }}>
                                            <MenuDots
                                                row={p}
                                                menuItens={menuItens}
                                                menuPositionTop={listagem.length - i <= 2}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                            {(!listagem || !listagem?.length) && (
                                <tr>
                                    <td colSpan={7}>Nenhum resultado encontrado.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div className="component pagination">
                        <div className="pagination-container mt-30">
                            {pager.total_pages < 2 ? (
                                ""
                            ) : (
                                <ReactPaginate
                                    previousLabel="«"
                                    nextLabel="»"
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    page={pager.page - 1 ?? 0}
                                    forcePage={pager.page - 1 ?? 0}
                                    pageCount={pager.total_pages}
                                    marginPagesDisplayed={3}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName="pagination"
                                    subContainerClassName="pages pagination"
                                    activeClassName="active"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
}
